import { Center, Container } from '@mantine/core';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
    return (
        <Center style={{ minHeight: '100vh', padding: '24px 12px' }}>
            <Container size={420} w="100%">
                <Outlet />
            </Container>
        </Center>
    );
}
